// angular
import { NgClass } from '@angular/common';
import {
  Component,
  effect,
  ElementRef,
  input,
  OnInit,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// interfaces
import { ISectionTab } from '@app/core/shared/interfaces/section-tab.interface';

@Component({
  selector: 'pwj-product-navigation-tabs',
  standalone: true,
  imports: [NgClass, TranslateModule],
  templateUrl: './product-navigation-tabs.component.html',
  styleUrl: './product-navigation-tabs.component.scss',
})
export class ProductNavigationTabsComponent implements OnInit {
  public activeSection = signal<string | null>(null);

  tabsData = input.required<ISectionTab[]>();
  activeSectionChange = output<string>();

  private readonly tabsNav = viewChild<ElementRef<HTMLElement>>('tabsNav');

  constructor() {
    effect(() => {
      const section = this.activeSection();
      if (section) {
        this.activeSectionChange.emit(section);
      }

      queueMicrotask(() => this.scrollActiveTabIntoView());
    });
  }

  ngOnInit() {
    const firstVisibleTab = this.tabsData().find(tab => !tab.hiddenTab);
    this.activeSection.set(firstVisibleTab?.tabTitle ?? null);
  }

  public trackByFn(index: number, tab: ISectionTab): string {
    return tab.tabTitle || index.toString();
  }

  public isTabActive(tab: ISectionTab): boolean {
    return this.activeSection() === tab.tabTitle;
  }

  public getTabLabel(tab: ISectionTab): string {
    return `products.${tab.tabTitle}`;
  }

  public onTabClick(tab: ISectionTab): void {
    if (this.activeSection() === tab.tabTitle) {
      return;
    }

    this.activeSection.set(tab.tabTitle);
  }

  private scrollActiveTabIntoView(): void {
    const nav = this.tabsNav()?.nativeElement;
    const activeLink = nav?.querySelector<HTMLElement>(
      '.product-nav-tabs__link--active',
    );

    activeLink?.scrollIntoView({
      inline: 'nearest',
      block: 'nearest',
      behavior: 'smooth',
    });
  }
}
